import React from 'react';
import PropTypes from 'prop-types';

const BlockQuote = ({ children }) => (
  <blockquote className="bg-gray-light8 relative p-8 pt-22 md:p-12 md:pl-44 before:content-[''] before:bg-big-quotes before:bg-no-repeat before:bg-cover before:absolute before:w-10 before:h-10 before:top-7 md:before:w-22.5 md:before:h-22 md:before:left-11 md:before:top14">
    <p className="text-lg tracking-normal leading-5 font-bold">{children}</p>
  </blockquote>
);

BlockQuote.propTypes = {
  children: PropTypes.node,
};

export default BlockQuote;
